module.exports = __webpack_public_path__ + "media/fonts/KumbhSans-Bold-48869b3d0d3794995f60990fc2edaff9.ttf";